export default __webpack_public_path__ + "static/media/NonaLovelace.96efdd40.png";